import { render, staticRenderFns } from "./LeadsObjectiveTemplate.vue?vue&type=template&id=22c3872e&scoped=true&"
import script from "./LeadsObjectiveTemplate.vue?vue&type=script&lang=js&"
export * from "./LeadsObjectiveTemplate.vue?vue&type=script&lang=js&"
import style0 from "./LeadsObjectiveTemplate.vue?vue&type=style&index=0&id=22c3872e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c3872e",
  null
  
)

export default component.exports